import { LineItemTab } from '../../../../../types/lineItemTabs'

interface GetActiveLineItemTabParams {
  requestedTab: LineItemTab
  isReferencedReturn: boolean
  shouldShowTabs: boolean
}

/**
 * Returns the valid active tab for the line-item details view.
 *
 * Fulfillment cannot be selected for referenced return sales, and tabs are
 * reset to Details when hidden, such as for service orders (e.g., when service order is added while viewing Fulfillment tab).
 * @param param0
 * @returns
 */
export const getActiveLineItemTab = ({
  requestedTab,
  isReferencedReturn,
  shouldShowTabs,
}: GetActiveLineItemTabParams): LineItemTab => {
  if (!shouldShowTabs) {
    return LineItemTab.DETAIL
  }

  if (isReferencedReturn && requestedTab === LineItemTab.FULFILMENT) {
    return LineItemTab.DETAIL
  }

  return requestedTab
}
